import React from "react";
import PreloaderComponentHtml from "components/preloader/PreloaderComponentHtml";

const SecurePreloader = () => {
	return <PreloaderComponentHtml />;
};

export default SecurePreloader;
